<template>
    <v-dialog v-model="dialog" max-width="500px" @click:outside="close" @keydown.esc="close">
        <v-card :loading="loading">
            <template slot="progress">
                <v-progress-linear background-color="primary" color="white" indeterminate bottom></v-progress-linear>
            </template>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                        v-model="editedItem.name"
                                        label="Abkürzung*"
                                        :rules="[v => !!v || 'Abkürzung ist ein Pflichtfeld']"
                                        required
                                        filled
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                        v-model="editedItem.name_full"
                                        label="Voller Name"
                                        filled
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                        v-model="editedItem.website"
                                        label="Website"
                                        filled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="close">Schließen</v-btn>
                    <v-btn color="primary" elevation="0" @click="save">Speichern</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import {RepositoryFactory} from "@/repositories/RepositoryFactory";

    const ChurchesRepository = RepositoryFactory.get('churches');

    export default {
        name: "DialogChurch",
        props: {
            dialog: Boolean,
            editedItem: Object,
            editedIndex: Number,
            formTitle: String,
        },
        data() {
            return {
                loading: false,
                valid: true,
            }
        },
        methods: {
            async save() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    if (this.editedIndex === -1) {
                        ChurchesRepository.add(this.editedItem.name, this.editedItem.name_full, this.editedItem.website)
                            .then(response => {
                                this.saved(response.data);
                                this.loading = false;
                                this.$store.dispatch('setMessage', 'Die Gemeinde "' + this.editedItem.name + '" wurde erfolgreich gespeichert.');
                            })
                            .catch(err => {
                                    this.close();
                                    this.loading = false;
                                    console.log(err);
                                    this.$store.dispatch('setMessage', 'Es ist leider ein Fehler aufgetreten.');
                                }
                            );
                    } else {
                        ChurchesRepository.update(this.editedItem.id, this.editedItem.name, this.editedItem.name_full, this.editedItem.website)
                            .then(response => {
                                this.saved(response.data);
                                this.loading = false;
                                this.$store.dispatch('setMessage', 'Die Gemeinde "' + this.editedItem.name + '" wurde erfolgreich geändert.');
                            })
                            .catch(err => {
                                    this.close();
                                    this.loading = false;
                                    console.log(err);
                                    this.$store.dispatch('setMessage', 'Es ist leider ein Fehler aufgetreten.');
                                }
                            );
                    }

                }
            },
            saved(item) {
                this.$emit('saved', item);
            },
            close() {
                this.$emit('close', this.editedItem);
            },
            reset() {
                this.$refs.form.reset()
            },
        }
    }
</script>

<style scoped>

</style>
